export interface IAmsDeskingHistory {
  createdBy?: string;
  createdDate: Date;
  amsDealerAppsId?: string; // USED BEFORE IMPORTING. Given after desking. This is the ID in the temporary internet apps table.
  amsApplicationNumber?: string; // USED AFTER IMPORTING. Created after the app is imported from internet apps in AMS 2000.
  amsAccountNumber?: string; // Also called loan number informally by AMS and their clients.
  amsPrimaryCustomerNumber?: string; // Given when posting the loan in AMS 2000
  amsCoAppCustomerNumber?: string; // Given when posting the loan in AMS 2000
  historyType: AmsDeskingHistoryType;
}

export enum AmsDeskingHistoryType
{
  Desk = 0,
  Post = 1
}